import dayjs from 'dayjs';

const formatDate = (date: string, format: string) => dayjs(date).format(format);

export default formatDate;

/**
 * Format a message/event timestamp for display in the dashboard.
 *
 * Uses abbreviated month (DD MMM YYYY) rather than DD/MM/YYYY because
 * the numeric form is ambiguous for non-EU users ("03/06/2025" reads
 * as March 6 in the US and June 3 in the EU). The abbreviated month
 * is unambiguous in every locale.
 *
 * Returns `null` when the input is missing or unparseable so callers
 * can conditionally render the timestamp span instead of showing the
 * literal string "Invalid Date" to users. The previous inline
 * `dayjs(created_at).format(...)` pattern produced "Invalid Date"
 * verbatim for any malformed input.
 */
export function formatMessageTimestamp(
  input: string | Date | undefined | null,
): string | null {
  if (!input) return null;
  const d = dayjs(input);
  if (!d.isValid()) return null;
  return d.format('DD MMM YYYY — HH:mm');
}
